import { styled } from 'goober';
import type { IsoGraph } from '../../../types';

const Select = styled('select')`
  width: 100%;
  padding: 6px 10px;
  border: 1px solid var(--input-border);
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text);
  background: white;
  transition: all 0.2s ease;
  &:focus {
    outline: none;
    border-color: var(--input-focus);
    box-shadow: 0 0 0 3px rgba(22, 160, 133, 0.1);
  }
  &:hover:not(:focus) {
    border-color: var(--text-muted);
  }
`;

interface GraphSelectProps {
  value: IsoGraph;
  onChange: (graph: IsoGraph) => void;
}

export function GraphSelect({ value, onChange }: GraphSelectProps) {
  const handleChange = (event: Event) => {
    onChange((event.target as HTMLSelectElement).value as IsoGraph);
  };

  return (
    <Select data-testid="iso-graph" id="iso-graph" value={value} onChange={handleChange}>
      <option value="Voiture">🚗 Voiture</option>
      <option value="Pieton">🚶 Piéton</option>
    </Select>
  );
}
